import React from 'react';
import { GenericIcon } from './GenericIcon.js';
export const createIcon = (path) => {
    const Component = (props) => (React.createElement(GenericIcon, { path: path, ...props }));
    return Component;
};
//# sourceMappingURL=createIcon.js.map